// extracted by mini-css-extract-plugin
export var root = "_2250981c7851203b130c44e0b968cff7-css";